(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["breadcrumb"] && !Shopify.designMode) return;
  try {
    
    const breadCrumbLinks = document.querySelectorAll(".breadcrumbs a")
  const lastLink = breadCrumbLinks[breadCrumbLinks.length - 1]
  lastLink.href = "javascript:void(0)"

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product-tabs-v2"] && !Shopify.designMode) return;
  try {
    
const featuredProductTabsInstances = new WeakMap();

function initFeaturedProductTabs(root) {
  if (featuredProductTabsInstances.has(root)) return;

  const controller = new AbortController();
  const tabs = Array.from(root.querySelectorAll('[data-featured-product-tabs-tab]'));
  const tabList = root.querySelector('.featured-product-tabs-v2__tab-list');
  const panels = Array.from(root.querySelectorAll('[data-featured-product-tabs-panel]'));
  const carousels = Array.from(root.querySelectorAll('[data-featured-product-tabs-carousel]'));

  if (tabList) {
    tabList.classList.toggle('featured-product-tabs-v2__tab-list--centered-mobile', tabs.length <= 2);
  }
  const updateControls = (carousel) => {
    const panel = carousel.closest('[data-featured-product-tabs-panel]');
    const previous = panel.querySelector('[data-featured-product-tabs-previous]');
    const next = panel.querySelector('[data-featured-product-tabs-next]');
    const maxScrollLeft = carousel.scrollWidth - carousel.clientWidth;
    const canScroll = maxScrollLeft > 1;

    previous.disabled = !canScroll || carousel.scrollLeft <= 1;
    next.disabled = !canScroll || carousel.scrollLeft >= maxScrollLeft - 1;
  };

  const updateAllControls = () => {
    carousels.forEach(updateControls);
  };

  const activateTab = (tab, focusTab) => {
    const panelId = tab.getAttribute('aria-controls');
    const selectedPanel = document.getElementById(panelId);

    tabs.forEach((item) => {
      const selected = item === tab;
      item.classList.toggle('is-active', selected);
      item.setAttribute('aria-selected', selected ? 'true' : 'false');
      item.tabIndex = selected ? 0 : -1;
    });

    panels.forEach((panel) => {
      panel.hidden = panel !== selectedPanel;
    });

    if (focusTab) tab.focus();

    requestAnimationFrame(updateAllControls);
  };

  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => activateTab(tab, false), { signal: controller.signal });

    tab.addEventListener(
      'keydown',
      (event) => {
        let nextIndex = index;

        if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = tabs.length - 1;

        if (nextIndex !== index || event.key === 'Home' || event.key === 'End') {
          event.preventDefault();
          activateTab(tabs[nextIndex], true);
        }
      },
      { signal: controller.signal }
    );
  });

  carousels.forEach((carousel) => {
    const panel = carousel.closest('[data-featured-product-tabs-panel]');
    const previous = panel.querySelector('[data-featured-product-tabs-previous]');
    const next = panel.querySelector('[data-featured-product-tabs-next]');
    const product = carousel.querySelector('.product-block');
    const scrollAmount = () => (product ? product.getBoundingClientRect().width : carousel.clientWidth);

    previous.addEventListener(
      'click',
      () => carousel.scrollBy({ left: -scrollAmount(), behavior: 'smooth' }),
      { signal: controller.signal }
    );

    next.addEventListener(
      'click',
      () => carousel.scrollBy({ left: scrollAmount(), behavior: 'smooth' }),
      { signal: controller.signal }
    );

    carousel.addEventListener('scroll', () => updateControls(carousel), {
      passive: true,
      signal: controller.signal,
    });
  });

  const resizeObserver = new ResizeObserver(updateAllControls);
  resizeObserver.observe(root);

  featuredProductTabsInstances.set(root, {
    destroy() {
      controller.abort();
      resizeObserver.disconnect();
    },
  });

  updateAllControls();
}

function initFeaturedProductTabsIn(container) {
  container.querySelectorAll('[data-featured-product-tabs]').forEach(initFeaturedProductTabs);
}

function destroyFeaturedProductTabsIn(container) {
  container.querySelectorAll('[data-featured-product-tabs]').forEach((root) => {
    const instance = featuredProductTabsInstances.get(root);
    if (!instance) return;

    instance.destroy();
    featuredProductTabsInstances.delete(root);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initFeaturedProductTabsIn(document), { once: true });
} else {
  initFeaturedProductTabsIn(document);
}

document.addEventListener('shopify:section:load', (event) => initFeaturedProductTabsIn(event.target));
document.addEventListener('shopify:section:unload', (event) => destroyFeaturedProductTabsIn(event.target));

  } catch(e) { console.error(e); }
})();
})();
